import { render } from "./ViewPeppolIdentifiers.vue?vue&type=template&id=16ae6d62&scoped=true"
import script from "./ViewPeppolIdentifiers.vue?vue&type=script&lang=js"
export * from "./ViewPeppolIdentifiers.vue?vue&type=script&lang=js"

import "./ViewPeppolIdentifiers.vue?vue&type=style&index=0&id=16ae6d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ae6d62"]])

export default __exports__